import { render, staticRenderFns } from "./source-of-wealth-manager.vue?vue&type=template&id=09062c00&"
import script from "./source-of-wealth-manager.ts?vue&type=script&lang=ts&"
export * from "./source-of-wealth-manager.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "source-of-wealth-manager.vue"
export default component.exports